export const InitialAppState = {
    fromCache:"",
    guid:"",
    homeUrl:"",
    menu:[],
    name:"",
    settings: null,
    appBrandingLoaded:false,
    defaultContentTitle:'',
    defaultContentId:0
}